import {
  Box,
  CircularProgress,
  CircularProgressProps,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect } from "react";
import { call_backend_api } from "../../../../services/APIWrapper";
import { LoggingService } from "../../../../services/openapi";

import { alpha } from "@mui/material/styles";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterList";
import { visuallyHidden } from "@mui/utils";
import UpdateIcon from "@mui/icons-material/Update";
import { Add, HdrPlus, PlusOne } from "@mui/icons-material";
import { Filter, FilterOption } from "./Filter";
interface ILogEntry_without_id {
  name: string;
  filename: string;
  lineno: number;
  process: number;
  message: string;
  severity: string;
  timestamp: string;
}

interface ILogEntry extends ILogEntry_without_id {
  id: number;
}

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

type Order = "asc" | "desc";

function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key
): (
  a: { [key in Key]: number | string },
  b: { [key in Key]: number | string }
) => number {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
// stableSort() brings sort stability to non-modern browsers (notably IE11). If you
// only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
// with exampleArray.slice().sort(exampleComparator)
function stableSort<T>(
  array: readonly T[],
  comparator: (a: T, b: T) => number
) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

interface HeadCell {
  disablePadding: boolean;
  id: keyof ILogEntry;
  label: string;
  numeric: boolean;
}

// "name": "application_logger",
//     "filename": "middleware.py",
//     "lineno": 13,
//     "process": 123,
//     "message": "",
//     "severity": "INFO",
//     "timestamp": "2024-05-15 18:30:30,507"

const headCells: readonly HeadCell[] = [
  {
    id: "severity",
    numeric: false,
    disablePadding: false,
    label: "Typ",
  },
  {
    id: "timestamp",
    numeric: false,
    disablePadding: false,
    label: "Zeitpunkt",
  },
  {
    id: "message",
    numeric: false,
    disablePadding: false,
    label: "Log Message",
  },
  //   {
  //     id: 'carbs',
  //     numeric: true,
  //     disablePadding: false,
  //     label: 'Carbs (g)',
  //   },
  //   {
  //     id: 'protein',
  //     numeric: true,
  //     disablePadding: false,
  //     label: 'Protein (g)',
  //   },
];

interface EnhancedTableProps {
  numSelected: number;
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof ILogEntry
  ) => void;
  onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  order: Order;
  orderBy: string;
  rowCount: number;
}

function EnhancedTableHead(props: EnhancedTableProps) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler =
    (property: keyof ILogEntry) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };

  return (
    <TableHead>
      <TableRow>
        {/* <TableCell padding="checkbox">
           <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              'aria-label': 'select all desserts',
            }}
          /> 
        </TableCell> */}
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden as any}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

interface EnhancedTableToolbarProps {
  numSelected: number;
  updateFunction?: Function;
  toggleFilterOptions?: Function;
  showFilterOptions: boolean;
  log_category: "application" | "backend_synchr" | "security";
  setLog_category: Function;
}

interface LogCategoryDict{
  [key:string]:string

}

function EnhancedTableToolbar(props: EnhancedTableToolbarProps) {
  const {
    numSelected,
    updateFunction = () => {},
    toggleFilterOptions = () => {},
    showFilterOptions,
    log_category,
    setLog_category
  } = props;

  const handleChange_select_Log_Category = (
    event: any
  ) => {
    setLog_category(
      event.target.value as "application" | "backend_synchr" | "security"
    );
  };
  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity
            ),
        }),
      }}
    >
      
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: "1 1 100%" }}
          color="inherit"
          variant="subtitle1"
          component="div"
          >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          sx={{  }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Logs
        </Typography>
        
      )}
      <FormControl sx={{ m: 1, minWidth: 170,  }} size="small">
              <InputLabel id="demo-select-small-label">Log Type</InputLabel>
              <Select
                labelId="demo-select-small-label"
                id="demo-select-small"
                value={log_category}
                label="Log Kategorie"
                onChange={handleChange_select_Log_Category}
              >
                {
                  [{value:"application",text:"Application"}, {value:"backend_synchr",text:"Background Syncronizer"}, {value:"security",text:"Security"}].map((log_category:LogCategoryDict) => 
                <MenuItem value={log_category.value}>{log_category.text}</MenuItem>)
              }
              </Select>
            </FormControl>
            <IconButton
        onClick={() => {
          updateFunction(log_category);
        }}
      >
            <UpdateIcon />
      </IconButton>
            <Box sx={{ flex: "1 1 100%" }} />
      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton
            onClick={() => {
              toggleFilterOptions(!showFilterOptions);
            }}
          >
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
}

export default function EnhancedTable(props: {
  rows: ILogEntry[];
  updateFunction?: Function;
  log_category: "application" | "backend_synchr" | "security";
  setLog_category: Function;
  loading:boolean;
}) {
  const { rows = [], updateFunction = () => {},log_category,setLog_category,loading } = props;
  const [tmpRows, setTmpRows] = React.useState<ILogEntry[]>(rows);
  const [order, setOrder] = React.useState<Order>("asc");
  const [orderBy, setOrderBy] = React.useState<keyof ILogEntry>("timestamp");
  const [selected, setSelected] = React.useState<readonly number[]>([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(true);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);
  const [filters, setFilters] = React.useState<FilterOption[]>([]);

  const [showFilterOptions, setShowFilterOptions] = React.useState(false);

  useEffect(() => {
    let tmp_rows = rows;
    tmp_rows = tmp_rows.filter((log_entry) => {
      return filters.reduce(
        (p, c) =>
          p === false
            ? false
            : c.operator === "includes"
            ? log_entry[c.column].includes(c.value)
            : !log_entry[c.column].includes(c.value),
        true
      );
    });
    setTmpRows(tmp_rows);
  }, [filters, rows]);

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof ILogEntry
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelected = tmpRows.map((n) => (n.id ? n.id : -1));
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event: React.MouseEvent<unknown>, id: number) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected: readonly number[] = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDense(event.target.checked);
  };

  const isSelected = (id: number) => selected.indexOf(id) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tmpRows.length) : 0;

  const visibleRows = React.useMemo(
    () =>
      stableSort(tmpRows, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, rowsPerPage, tmpRows]
  );

  return (
    <Box sx={{ width: "100%" }}>
      <Paper sx={{ width: "100%", mb: 2 }}>
        <EnhancedTableToolbar
          numSelected={selected.length}
          updateFunction={updateFunction}
          toggleFilterOptions={setShowFilterOptions}
          showFilterOptions={showFilterOptions}
          setLog_category={setLog_category}
          log_category={log_category}
        />
        <Filter
          showFilterOptions={showFilterOptions}
          updateFilters={setFilters}
        ></Filter>
        <TableContainer>
          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size={dense ? "small" : "medium"}
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={tmpRows.length}
            />
            <TableBody>
              {(!loading) && visibleRows.map((row, index) => {
                const isItemSelected = isSelected(row.id);
                const labelId = `enhanced-table-checkbox-${index}`;

                return (
                  <TableRow
                    hover
                    // onClick={(event) => handleClick(event, row.id)}
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row.id}
                    selected={isItemSelected}
                    sx={{ cursor: "pointer" }}
                  >
                    {/* <TableCell padding="checkbox">
                      <Checkbox
                        color="primary"
                        checked={isItemSelected}
                        inputProps={{
                          'aria-labelledby': labelId,
                        }}
                      />
                    </TableCell> */}
                    <TableCell
                      component="th"
                      id={labelId}
                      scope="row"
                      // padding="none"
                    >
                      {row.severity}
                    </TableCell>
                    {/* <TableCell align="right">{row.severity}</TableCell> */}
                    <TableCell align="left">{row.timestamp}</TableCell>
                    <TableCell align="left">{row.message}</TableCell>
                    {/* <TableCell align="right">{row.protein}</TableCell> */}
                  </TableRow>
                );
              })}
              {
                (loading) && <TableRow>
                  <TableCell colSpan={3} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              }
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: (dense ? 33 : 53) * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[100, 200, 500]}
          component="div"
          count={tmpRows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
      {/* <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label="Dense padding"
      /> */}
    </Box>
  );
}

export const Logs = () => {
  //const [percentage, setPercentage] = React.useState(100);
  const [logEntries, setLogEntries] = React.useState<ILogEntry[]>([]);
  const [kindOfLogs, setKindOfLogs] = React.useState<"application" | "backend_synchr" | "security">("application");
  const [loading, setLoading] = React.useState<boolean>(false);
  const update = (
    log_category: "application" | "backend_synchr" | "security"
  ) =>{
    setLoading(true);
    setLogEntries([]);
    call_backend_api(
      LoggingService.provideEndpointListLoggingLogsGet(log_category),
    (res: ILogEntry_without_id[]) => {

    setLogEntries(
      res.map((entry: ILogEntry_without_id, idx) => ({ ...entry, id: idx }))
    );
    setLoading(false);
  }
)
};

  useEffect(() => {
    update(kindOfLogs);
  }, [kindOfLogs]);
  

  return (
    <>
      <Container component="main">
        {/* <Typography variant="h4">Logs</Typography> */}
        {/* <CssBaseline /> */}

        <Box>
          <>
            
            <EnhancedTable rows={logEntries} updateFunction={update} log_category={kindOfLogs} setLog_category={setKindOfLogs} loading={loading}/>
            {
              // logEntries.map((entry:ILogEntry)=>
              //      (
              //         <Box key={entry.timestamp}>
              //             <Typography>{entry.timestamp}</Typography>
              //             <Typography>{entry.severity}</Typography>
              //             <Typography>{entry.message}</Typography>
              //         </Box>
              //     ))
            }
          </>
          {/* <Typography>Gesamter Speicherplatz: {availableSpace.maxCapacity?availableSpace.maxCapacity.size && availableSpace.maxCapacity.unit?availableSpace.maxCapacity.size+" "+availableSpace.maxCapacity.unit:"":""}</Typography>
          <Typography>Verwendeter Speicherplatz: {availableSpace.usedCapacity?availableSpace.usedCapacity.size && availableSpace.usedCapacity.unit?availableSpace.usedCapacity.size.toFixed(2)+" "+availableSpace.usedCapacity.unit:"":""}</Typography>
          <Typography>Freier Speicherplatz: {availableSpace.freeCapacity?availableSpace.freeCapacity.size && availableSpace.freeCapacity.unit?availableSpace.freeCapacity.size.toFixed(2)+" "+availableSpace.freeCapacity.unit:"":""}</Typography> */}
        </Box>
      </Container>
    </>
  );
};
